<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="rearing" title="솔루션" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                식물공장 시설
            </template>
            <tit-wrap-large class="mb-0">
                더욱 높은 품질의 농작물 생산을 <br class="d-none d-lg-block" />가능하게 하는 <b>양액재배 관리시스템</b>
                <template #text> 작물재배환경의 기본이 되는 근권환경측정 제어장치 기술을 바탕으로 <br class="d-none d-lg-block" />작물에 가장 적합한 양액을 공급하여 최상 상태의 작물을 수확하는 정밀농업이 가능해집니다. </template>
            </tit-wrap-large>
        </page-section>

        <page-section class="page-section--last grey lighten-5">
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <v-row class="mx-n20px my-n10px mx-md-n30px my-md-n20px">
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-left" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-img max-width="570" :aspect-ratio="570 / 456" src="/images/sub/solution/plant/rearing-img.jpg" class="mx-auto" />
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-right" data-aos-delay="200">
                            <div class="mt-md-24px">
                                <tit-wrap-sprout>
                                    식물공장 재배대 시스템
                                    <template #text>
                                        시설재배 작물 생장환경 실시간 모니터링 장비
                                    </template>
                                </tit-wrap-sprout>

                                <txt-item>
                                    <template #title>구성</template>
                                    급액 감지부, 배액 감지부, 무게 감지부, 양액 공급부, 디스플레이, 컨트롤유닛, 경고부
                                </txt-item>
                                <div class="mt-16px mt-md-24px">
                                    <v-img max-width="570" :aspect-ratio="570 / 158" src="/images/sub/solution/plant/rearing-img2.png" class="mx-auto" />
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card outlined rounded="" data-aos="fade" data-aos-delay="100">
                        <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                            <div class="pa-30px pa-md-40px px-lg-80px">
                                <v-img max-width="696" :aspect-ratio="696 / 474" src="/images/sub/solution/plant/rearing-img3.jpg" class="mx-auto" />
                                <div class="pt-30px pt-md-40px pt-lg-60px">
                                    <tit-wrap-small>
                                        <template #text> 재배 시스템에 여러 사항들에 대한 수치를 입력해 놓으면, 미리 설정된 임계값 범위에서 벗어날 때 <br class="d-none d-lg-block" />경고부를 통해 위험 요소를 사전에 전달하여 가장 효율적인 재배가 가능하도록 합니다. </template>
                                    </tit-wrap-small>
                                </div>
                            </div>
                        </v-responsive>
                    </v-card>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-row justify="center">
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="100">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/plant/rearing-img4.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                특허등록
                                <template #text>
                                    양액재배 관리장치
                                </template>
                            </tit-wrap-small>
                        </v-col>
                    </v-row>
                </template>
            </page-section>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
    },
    props: {},
    data() {
        return {
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
